<template>
  <div>Hook Field</div>
</template>

<script>
import form_field from "../../../mixin/form-field.js";
export default {
  name: "form_hook_field",
  mixins: [form_field]
};
</script>
